import { useStore } from 'effector-react'

import {
  $errorHistoryLoginsRequest,
  $historyLogins,
  $totalCountOfHistoryLogins,
  getHistoryLogins,
  historyLoginsMounted,
} from './model'
import { HistoryLoginRequest } from './types'

export const useHistoryLoginsWidget = () => {
  const onChangeHistoryLoginsList = ({
    limit,
    page,
    sorterField,
  }: HistoryLoginRequest) => {
    historyLoginsMounted({
      limit,
      page,
      sorterField,
    })
  }
  const historyLogins = useStore($historyLogins)
  const totalCountOfHistoryLogins = useStore($totalCountOfHistoryLogins)

  const loading = useStore(getHistoryLogins.pending)
  const errorHistoryLoginsRequest = useStore($errorHistoryLoginsRequest)

  return {
    historyLogins,
    loading,
    totalCountOfHistoryLogins,
    onChangeHistoryLoginsList,
    errorHistoryLoginsRequest,
  }
}
